function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingSettlement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7E7FF"
    },
    d: "M405.382,254.426l-7.636-90.629c-5.206-61.792-61.45-106.391-122.802-97.377l-16.681,2.451 c-24.986,3.671-47.884,16.018-64.68,34.877l-72.105,80.959c-42.926,48.198-34.03,123.085,18.993,159.884l52.283,36.286 c36.089,25.047,83.783,25.627,120.471,1.467l44.138-29.067C390.267,331.608,408.69,293.684,405.382,254.426z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#B3CEFF"
    },
    cx: 250,
    cy: 455.521,
    rx: 191.171,
    ry: 9.557
  })))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#637F0D"
    },
    d: "M333.537,422.565h77.099c3.616,0,6.547,2.931,6.547,6.547v18.538c0,3.616-2.931,6.547-6.547,6.547 h-77.099c-0.761,0-1.378-0.617-1.378-1.378v-28.874C332.159,423.182,332.776,422.565,333.537,422.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82960D"
    },
    d: "M360.329,422.565h70.38c3.828,0,6.93,3.103,6.93,6.931v17.77c0,3.828-3.103,6.931-6.93,6.931 h-70.38V422.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB600"
    },
    d: "M412.993,422.565v31.631h23.967c0.376,0,0.68-0.486,0.68-1.085V423.65 c0-0.599-0.304-1.085-0.68-1.085H412.993z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.646,
    y: 422.565,
    style: {
      fill: "#AFB600"
    },
    width: 8.724,
    height: 31.631
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 359.091,
    y: 425.114,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.091,
    y: 428.701,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.091,
    y: 432.288,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.091,
    y: 435.874,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.091,
    y: 439.461,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.091,
    y: 443.048,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.091,
    y: 446.635,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.091,
    y: 450.222,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 373.6,
    y: 422.045,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.281,
    height: 32.429
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.6,
    y: 437.785,
    style: {
      fill: "#D0EFF4"
    },
    width: 22.281,
    height: 16.689
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#637F0D"
    },
    d: "M316.251,390.952h77.099c3.616,0,6.547,2.931,6.547,6.547v18.538c0,3.616-2.931,6.547-6.547,6.547 h-77.099c-0.761,0-1.378-0.617-1.378-1.378v-28.874C314.873,391.569,315.49,390.952,316.251,390.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82960D"
    },
    d: "M343.043,390.952h70.38c3.828,0,6.931,3.103,6.931,6.931v17.77c0,3.828-3.103,6.931-6.931,6.931 h-70.38V390.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB600"
    },
    d: "M395.707,390.952v31.631h23.967c0.375,0,0.68-0.486,0.68-1.085v-29.462 c0-0.599-0.305-1.085-0.68-1.085H395.707z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.36,
    y: 390.952,
    style: {
      fill: "#AFB600"
    },
    width: 8.723,
    height: 31.631
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 341.805,
    y: 393.501,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.805,
    y: 397.088,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.805,
    y: 400.674,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.805,
    y: 404.261,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.805,
    y: 407.848,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.805,
    y: 411.435,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.805,
    y: 415.022,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.805,
    y: 418.609,
    style: {
      fill: "#637F0D"
    },
    width: 78.537,
    height: 1.426
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 356.315,
    y: 390.432,
    style: {
      fill: "#FFFFFF"
    },
    width: 22.281,
    height: 32.429
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.315,
    y: 406.172,
    style: {
      fill: "#D0EFF4"
    },
    width: 22.281,
    height: 16.689
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00340a"
    },
    points: "109.739,257.911 75.034,454.196 144.159,454.196 144.159,267.477  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 109.739,
    y: 257.911,
    style: {
      fill: "#0e4d1a"
    },
    width: 241.182,
    height: 196.358
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.717,
    y: 245.066,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 586.4207 125.7603)",
    style: {
      fill: "#FFFFFF"
    },
    width: 177.226,
    height: 222.05
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D7E7FF"
    },
    points: "121.662,386.038 119.305,388.223 119.305,444.703 159.645,444.703  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7E7FF",
      strokeMiterlimit: 10
    },
    x1: 180.632,
    y1: 297.669,
    x2: 180.632,
    y2: 428.567
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7E7FF",
      strokeMiterlimit: 10
    },
    x1: 230.883,
    y1: 297.669,
    x2: 230.883,
    y2: 428.567
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7E7FF",
      strokeMiterlimit: 10
    },
    x1: 281.134,
    y1: 297.669,
    x2: 281.134,
    y2: 428.567
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7E7FF",
      strokeMiterlimit: 10
    },
    x1: 315.137,
    y1: 339.774,
    x2: 146.629,
    y2: 339.774
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#D7E7FF",
      strokeMiterlimit: 10
    },
    x1: 315.137,
    y1: 390.025,
    x2: 146.629,
    y2: 390.025
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00340a"
    },
    cx: 151.704,
    cy: 282.569,
    r: 8.645
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA840"
    },
    d: "M151.704,287.245L151.704,287.245c-3.209,0-5.811-2.602-5.811-5.811v-31.656 c0-3.209,2.602-5.811,5.811-5.811l0,0c3.209,0,5.811,2.602,5.811,5.811v31.656 C157.515,284.644,154.913,287.245,151.704,287.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF833E"
    },
    d: "M151.704,278.041c-3.209,0-5.811-2.601-5.811-5.81v9.205c0,3.209,2.602,5.811,5.811,5.811 c3.209,0,5.811-2.602,5.811-5.811v-9.205C157.515,275.439,154.913,278.041,151.704,278.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC943"
    },
    d: "M151.704,263.722L151.704,263.722c-3.209,0-5.811-2.601-5.811-5.811v-8.132 c0-3.209,2.602-5.811,5.811-5.811l0,0c3.209,0,5.811,2.602,5.811,5.811v8.132 C157.515,261.12,154.913,263.722,151.704,263.722z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00340a"
    },
    cx: 230.33,
    cy: 282.569,
    r: 8.645
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA840"
    },
    d: "M230.33,287.245L230.33,287.245c-3.209,0-5.811-2.602-5.811-5.811v-31.656 c0-3.209,2.601-5.811,5.811-5.811h0c3.209,0,5.811,2.602,5.811,5.811v31.656C236.141,284.644,233.539,287.245,230.33,287.245 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF833E"
    },
    d: "M230.33,278.041c-3.209,0-5.811-2.601-5.811-5.81v9.205c0,3.209,2.602,5.811,5.811,5.811 c3.209,0,5.811-2.602,5.811-5.811v-9.205C236.141,275.439,233.539,278.041,230.33,278.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC943"
    },
    d: "M230.33,263.722L230.33,263.722c-3.209,0-5.811-2.601-5.811-5.811v-8.132 c0-3.209,2.601-5.811,5.811-5.811h0c3.209,0,5.811,2.602,5.811,5.811v8.132C236.141,261.12,233.539,263.722,230.33,263.722z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00340a"
    },
    cx: 308.956,
    cy: 282.569,
    r: 8.645
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA840"
    },
    d: "M308.956,287.245L308.956,287.245c-3.209,0-5.811-2.602-5.811-5.811v-31.656 c0-3.209,2.602-5.811,5.811-5.811l0,0c3.209,0,5.811,2.602,5.811,5.811v31.656 C314.767,284.644,312.165,287.245,308.956,287.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF833E"
    },
    d: "M308.956,278.041c-3.209,0-5.811-2.601-5.811-5.81v9.205c0,3.209,2.602,5.811,5.811,5.811 c3.209,0,5.811-2.602,5.811-5.811v-9.205C314.767,275.439,312.165,278.041,308.956,278.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC943"
    },
    d: "M308.956,263.722L308.956,263.722c-3.209,0-5.811-2.601-5.811-5.811v-8.132 c0-3.209,2.602-5.811,5.811-5.811l0,0c3.209,0,5.811,2.602,5.811,5.811v8.132 C314.767,261.12,312.165,263.722,308.956,263.722z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB600"
    },
    d: "M149.014,332.498c-6.734,0-12.212-5.478-12.212-12.212c0-6.733,5.478-12.212,12.212-12.212 c6.734,0,12.212,5.478,12.212,12.212C161.227,327.02,155.748,332.498,149.014,332.498z M149.014,311.964 c-4.589,0-8.323,3.734-8.323,8.322c0,4.589,3.733,8.323,8.323,8.323c4.589,0,8.323-3.734,8.323-8.323 C157.337,315.697,153.604,311.964,149.014,311.964z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#637F0D"
    },
    points: "151.241,324.733 147.215,320.706 149.278,318.644 151.241,320.608 170.562,301.287  172.624,303.349  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB600"
    },
    d: "M202.274,332.498c-6.734,0-12.212-5.478-12.212-12.212c0-6.733,5.478-12.212,12.212-12.212 c6.734,0,12.213,5.478,12.213,12.212C214.487,327.02,209.008,332.498,202.274,332.498z M202.274,311.964 c-4.589,0-8.323,3.734-8.323,8.322c0,4.589,3.733,8.323,8.323,8.323s8.323-3.734,8.323-8.323 C210.598,315.697,206.864,311.964,202.274,311.964z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#637F0D"
    },
    points: "204.501,324.733 200.475,320.706 202.538,318.644 204.501,320.608 223.822,301.287  225.884,303.349  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB600"
    },
    d: "M255.535,332.498c-6.734,0-12.212-5.478-12.212-12.212c0-6.733,5.478-12.212,12.212-12.212 c6.734,0,12.212,5.478,12.212,12.212C267.747,327.02,262.268,332.498,255.535,332.498z M255.535,311.964 c-4.589,0-8.323,3.734-8.323,8.322c0,4.589,3.733,8.323,8.323,8.323s8.323-3.734,8.323-8.323 C263.858,315.697,260.124,311.964,255.535,311.964z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#637F0D"
    },
    points: "257.761,324.733 253.735,320.706 255.798,318.644 257.761,320.608 277.082,301.287  279.144,303.349  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB600"
    },
    d: "M308.795,332.498c-6.734,0-12.212-5.478-12.212-12.212c0-6.733,5.478-12.212,12.212-12.212 c6.734,0,12.212,5.478,12.212,12.212C321.007,327.02,315.529,332.498,308.795,332.498z M308.795,311.964 c-4.589,0-8.323,3.734-8.323,8.322c0,4.589,3.734,8.323,8.323,8.323c4.588,0,8.322-3.734,8.322-8.323 C317.117,315.697,313.383,311.964,308.795,311.964z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#637F0D"
    },
    points: "311.022,324.733 306.996,320.706 309.058,318.644 311.022,320.608 330.342,301.287  332.404,303.349  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB600"
    },
    d: "M149.014,378.689c-6.734,0-12.212-5.478-12.212-12.212c0-6.734,5.478-12.213,12.212-12.213 c6.734,0,12.212,5.478,12.212,12.213C161.227,373.211,155.748,378.689,149.014,378.689z M149.014,358.154 c-4.589,0-8.323,3.734-8.323,8.323c0,4.588,3.733,8.322,8.323,8.322c4.589,0,8.323-3.734,8.323-8.322 C157.337,361.888,153.604,358.154,149.014,358.154z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#637F0D"
    },
    points: "151.241,370.923 147.215,366.897 149.278,364.834 151.241,366.798 170.562,347.477  172.624,349.54  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB600"
    },
    d: "M202.274,378.689c-6.734,0-12.212-5.478-12.212-12.212c0-6.734,5.478-12.213,12.212-12.213 c6.734,0,12.213,5.478,12.213,12.213C214.487,373.211,209.008,378.689,202.274,378.689z M202.274,358.154 c-4.589,0-8.323,3.734-8.323,8.323c0,4.588,3.733,8.322,8.323,8.322s8.323-3.734,8.323-8.322 C210.598,361.888,206.864,358.154,202.274,358.154z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#637F0D"
    },
    points: "204.501,370.923 200.475,366.897 202.538,364.834 204.501,366.798 223.822,347.477  225.884,349.54  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3CEFF"
    },
    d: "M255.535,378.689c-6.734,0-12.212-5.478-12.212-12.212c0-6.734,5.478-12.213,12.212-12.213 c6.734,0,12.212,5.478,12.212,12.213C267.747,373.211,262.268,378.689,255.535,378.689z M255.535,358.154 c-4.589,0-8.323,3.734-8.323,8.323c0,4.588,3.733,8.322,8.323,8.322s8.323-3.734,8.323-8.322 C263.858,361.888,260.124,358.154,255.535,358.154z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3CEFF"
    },
    d: "M308.795,378.689c-6.734,0-12.212-5.478-12.212-12.212c0-6.734,5.478-12.213,12.212-12.213 c6.734,0,12.212,5.478,12.212,12.213C321.007,373.211,315.529,378.689,308.795,378.689z M308.795,358.154 c-4.589,0-8.323,3.734-8.323,8.323c0,4.588,3.734,8.322,8.323,8.322c4.588,0,8.322-3.734,8.322-8.322 C317.117,361.888,313.383,358.154,308.795,358.154z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3CEFF"
    },
    d: "M149.014,424.88c-6.734,0-12.212-5.478-12.212-12.212s5.478-12.213,12.212-12.213 c6.734,0,12.212,5.478,12.212,12.213S155.748,424.88,149.014,424.88z M149.014,404.345c-4.589,0-8.323,3.734-8.323,8.323 s3.733,8.323,8.323,8.323c4.589,0,8.323-3.734,8.323-8.323S153.604,404.345,149.014,404.345z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3CEFF"
    },
    d: "M202.274,424.88c-6.734,0-12.212-5.478-12.212-12.212s5.478-12.213,12.212-12.213 c6.734,0,12.213,5.478,12.213,12.213S209.008,424.88,202.274,424.88z M202.274,404.345c-4.589,0-8.323,3.734-8.323,8.323 s3.733,8.323,8.323,8.323s8.323-3.734,8.323-8.323S206.864,404.345,202.274,404.345z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3CEFF"
    },
    d: "M255.535,424.88c-6.734,0-12.212-5.478-12.212-12.212s5.478-12.213,12.212-12.213 c6.734,0,12.212,5.478,12.212,12.213S262.268,424.88,255.535,424.88z M255.535,404.345c-4.589,0-8.323,3.734-8.323,8.323 s3.733,8.323,8.323,8.323s8.323-3.734,8.323-8.323S260.124,404.345,255.535,404.345z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3CEFF"
    },
    d: "M308.795,424.88c-6.734,0-12.212-5.478-12.212-12.212s5.478-12.213,12.212-12.213 c6.734,0,12.212,5.478,12.212,12.213S315.529,424.88,308.795,424.88z M308.795,404.345c-4.589,0-8.323,3.734-8.323,8.323 s3.734,8.323,8.323,8.323c4.588,0,8.322-3.734,8.322-8.323S313.383,404.345,308.795,404.345z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF833E"
    },
    d: "M132.004,456.885H87.303c-1.96,0-3.549-1.589-3.549-3.549v-7.873c0-1.96,1.589-3.549,3.549-3.549 h44.701c1.96,0,3.549,1.589,3.549,3.549v7.873C135.552,455.296,133.963,456.885,132.004,456.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA840"
    },
    d: "M119.541,456.885H74.84c-1.96,0-3.549-1.589-3.549-3.549v-7.873c0-1.96,1.589-3.549,3.549-3.549 h44.701c1.96,0,3.549,1.589,3.549,3.549v7.873C123.089,455.296,121.501,456.885,119.541,456.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC943"
    },
    d: "M95.244,456.885v-14.97H74.211c-1.612,0-2.919,1.307-2.919,2.919v9.132 c0,1.612,1.307,2.919,2.919,2.919H95.244z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.126,
    y: 441.914,
    style: {
      fill: "#FFC943"
    },
    width: 5.314,
    height: 14.97
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.247,
    y: 441.914,
    style: {
      fill: "#FFC943"
    },
    width: 2.807,
    height: 14.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF833E"
    },
    d: "M119.541,441.989H74.84c-1.96,0-3.549-1.589-3.549-3.549v-7.873c0-1.96,1.589-3.549,3.549-3.549 h44.701c1.96,0,3.549,1.589,3.549,3.549v7.873C123.089,440.4,121.501,441.989,119.541,441.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA840"
    },
    d: "M107.078,441.989H62.377c-1.96,0-3.549-1.589-3.549-3.549v-7.873c0-1.96,1.589-3.549,3.549-3.549 h44.701c1.96,0,3.549,1.589,3.549,3.549v7.873C110.626,440.4,109.038,441.989,107.078,441.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC943"
    },
    d: "M82.781,441.989v-14.97H61.748c-1.612,0-2.919,1.307-2.919,2.919v9.132 c0,1.612,1.307,2.919,2.919,2.919H82.781z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.663,
    y: 427.019,
    style: {
      fill: "#FFC943"
    },
    width: 5.314,
    height: 14.97
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.785,
    y: 427.019,
    style: {
      fill: "#FFC943"
    },
    width: 2.807,
    height: 14.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF833E"
    },
    d: "M123.77,427.093H79.069c-1.96,0-3.549-1.589-3.549-3.549v-7.873c0-1.96,1.589-3.549,3.549-3.549 h44.701c1.96,0,3.549,1.589,3.549,3.549v7.873C127.318,425.505,125.73,427.093,123.77,427.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA840"
    },
    d: "M111.307,427.093H66.606c-1.96,0-3.549-1.589-3.549-3.549v-7.873c0-1.96,1.589-3.549,3.549-3.549 h44.701c1.96,0,3.549,1.589,3.549,3.549v7.873C114.856,425.505,113.267,427.093,111.307,427.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC943"
    },
    d: "M87.01,427.093v-14.97H65.977c-1.612,0-2.919,1.307-2.919,2.919v9.132 c0,1.612,1.307,2.919,2.919,2.919H87.01z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.892,
    y: 412.123,
    style: {
      fill: "#FFC943"
    },
    width: 5.314,
    height: 14.97
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.014,
    y: 412.123,
    style: {
      fill: "#FFC943"
    },
    width: 2.807,
    height: 14.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF833E"
    },
    d: "M119.541,412.198H74.84c-1.96,0-3.549-1.589-3.549-3.549v-7.873c0-1.96,1.589-3.549,3.549-3.549 h44.701c1.96,0,3.549,1.589,3.549,3.549v7.873C123.089,410.609,121.501,412.198,119.541,412.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA840"
    },
    d: "M107.078,412.198H62.377c-1.96,0-3.549-1.589-3.549-3.549v-7.873c0-1.96,1.589-3.549,3.549-3.549 h44.701c1.96,0,3.549,1.589,3.549,3.549v7.873C110.626,410.609,109.038,412.198,107.078,412.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC943"
    },
    d: "M82.781,412.198v-14.97H61.748c-1.612,0-2.919,1.307-2.919,2.919v9.132 c0,1.612,1.307,2.919,2.919,2.919H82.781z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.663,
    y: 397.227,
    style: {
      fill: "#FFC943"
    },
    width: 5.314,
    height: 14.97
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.785,
    y: 397.227,
    style: {
      fill: "#FFC943"
    },
    width: 2.807,
    height: 14.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF833E"
    },
    d: "M123.77,397.302H79.069c-1.96,0-3.549-1.589-3.549-3.549v-7.873c0-1.96,1.589-3.549,3.549-3.549 h44.701c1.96,0,3.549,1.589,3.549,3.549v7.873C127.318,395.714,125.73,397.302,123.77,397.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA840"
    },
    d: "M111.307,397.302H66.606c-1.96,0-3.549-1.589-3.549-3.549v-7.873c0-1.96,1.589-3.549,3.549-3.549 h44.701c1.96,0,3.549,1.589,3.549,3.549v7.873C114.856,395.714,113.267,397.302,111.307,397.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC943"
    },
    d: "M87.01,397.302v-14.97H65.977c-1.612,0-2.919,1.307-2.919,2.919v9.132 c0,1.612,1.307,2.919,2.919,2.919H87.01z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.892,
    y: 382.332,
    style: {
      fill: "#FFC943"
    },
    width: 5.314,
    height: 14.97
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.014,
    y: 382.332,
    style: {
      fill: "#FFC943"
    },
    width: 2.807,
    height: 14.97
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 322.323,
    y: 343.457,
    transform: "matrix(0.0073 -1 1 0.0073 46.0726 747.5432)",
    style: {
      fill: "#FFB692"
    },
    width: 154.441,
    height: 14.219
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 390.095,
    y: 408.338,
    style: {
      fill: "#488153"
    },
    width: 18.051,
    height: 21.444
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.095,
    y: 414.486,
    style: {
      fill: "#0e4d1a"
    },
    width: 18.051,
    height: 5.185
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B77674"
    },
    points: "392.453,346.638 406.673,346.638 406.882,339.796 392.662,339.796  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#488153"
    },
    points: "389.083,343.217 388.463,272.341 409.435,272.2 410.055,343.077  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#488153"
    },
    d: "M392.089,254.445l-14.883,0c-10.978,0-19.96,8.982-19.96,19.96v0 c0,10.978,8.982,19.96,19.96,19.96h14.883c10.978,0,19.96-8.982,19.96-19.96v0C412.048,263.427,403.067,254.445,392.089,254.445z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 364.057,
    y: 273.346,
    transform: "matrix(1 -0.0073 0.0073 1 -2.5468 2.7162)",
    style: {
      fill: "#FFB692"
    },
    width: 14.219,
    height: 154.441
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 362.152,
    y: 408.338,
    style: {
      fill: "#488153"
    },
    width: 18.051,
    height: 21.444
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.152,
    y: 414.486,
    style: {
      fill: "#0e4d1a"
    },
    width: 18.051,
    height: 5.185
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B77674"
    },
    points: "378.258,346.638 364.038,346.638 363.829,339.796 378.049,339.796  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#488153"
    },
    points: "381.628,343.217 382.248,272.341 361.276,272.2 360.656,343.077  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0e4d1a"
    },
    points: "389.083,343.217 389.035,333.395 410.03,333.384 410.055,343.206  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0e4d1a"
    },
    points: "381.628,343.217 381.676,333.395 360.681,333.384 360.656,343.206  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF833E"
    },
    d: "M359.339,425.32l0.11,12.747c0,0-13.279,0.222-17.168,17.794l39.741-0.038V425.32H359.339z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M360.353,433.395h7.891c1.17,0,2.118-0.948,2.118-2.118l0,0c0-1.17-0.948-2.118-2.118-2.118 h-7.891c-1.17,0-2.118,0.948-2.118,2.118l0,0C358.235,432.447,359.184,433.395,360.353,433.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M360.353,439.538h7.891c1.17,0,2.118-0.948,2.118-2.118l0,0c0-1.17-0.948-2.118-2.118-2.118 h-7.891c-1.17,0-2.118,0.948-2.118,2.118l0,0C358.235,438.59,359.184,439.538,360.353,439.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M350.076,441.952c2.517,2.562,4.919,6.917,3.872,13.898l-11.666,0.011 C343.849,448.779,346.942,444.518,350.076,441.952z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.605,
    y: 454.925,
    style: {
      fill: "#488153"
    },
    width: 41.314,
    height: 3.595
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA840"
    },
    d: "M388.097,425.32l0.11,12.747c0,0-13.279,0.222-17.168,17.794l39.741-0.038V425.32H388.097z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M389.111,433.395h7.891c1.17,0,2.118-0.948,2.118-2.118l0,0c0-1.17-0.948-2.118-2.118-2.118 h-7.891c-1.17,0-2.118,0.948-2.118,2.118l0,0C386.992,432.447,387.941,433.395,389.111,433.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M389.111,439.538h7.891c1.17,0,2.118-0.948,2.118-2.118l0,0c0-1.17-0.948-2.118-2.118-2.118 h-7.891c-1.17,0-2.118,0.948-2.118,2.118l0,0C386.992,438.59,387.941,439.538,389.111,439.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M378.833,441.952c2.517,2.562,4.919,6.917,3.872,13.898l-11.666,0.011 C372.607,448.779,375.7,444.518,378.833,441.952z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.363,
    y: 454.925,
    style: {
      fill: "#9B8DFF"
    },
    width: 41.314,
    height: 3.595
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFB692",
      strokeWidth: 10,
      strokeMiterlimit: 10
    },
    d: "M365.425,190.42 c-17.189,28.744-26.482,62.711-98.475,34.287"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464668"
    },
    d: "M356.915,192.484c-3.174,4.373-9.019,11.346-17.647,17.486l12.558,13.802 c0,0,10.388-7.163,20.453-19.199c6.526-7.804-0.67-12.387-6.538-14.645C362.552,188.7,358.923,189.718,356.915,192.484z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB692"
    },
    d: "M268.78,230.693c7.643-4.554-0.873-14.295-0.873-14.295l-0.463-9.024c0,0-8.02,0.762-5.866,8.543 c0,0-8.928-7.086-13.813-6.334c-2.294,0.353-7.85,7.447-8.745,12.201c-0.19,1.008,0.484,1.966,1.496,2.129 c2.432,0.393,7.192,1.653,10.399,5.652C255.383,235.137,264.313,240.049,268.78,230.693z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M261.578,215.917c0,0-4.441,4.91-0.2,11.347c0,0-2.74-6.314,0.601-11.022L261.578,215.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M254.098,226.791c0,0,1.066-5.259,4.635-9.273C258.733,217.517,253.124,218.97,254.098,226.791z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M254.56,224.81l0.043-0.435c0,0-7.834-4.631-15.324-3.631c-0.044,0.146-0.084,0.29-0.12,0.433 C242.022,221.096,248.833,221.329,254.56,224.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M256.778,219.179l0.53-0.467c0,0-6.103-6.755-12.975-6.486 c-1.135,1.275-2.305,2.885-3.268,4.553c2.215-0.004,8.778,0.413,14.141,5.119l0.314-0.443c0,0-6.117-6.817-13.786-5.47 l2.138-3.205C243.872,212.78,251.232,212.745,256.778,219.179z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M356.253,269.624c-0.014,2.538,1.416,4.88,3.705,5.974c5.069,2.422,12.431,5.075,21.569,5.716 c12.862,0.902,23.193-2.604,29.362-5.441c2.324-1.069,3.801-3.405,3.815-5.962c0.124-23.066,0.247-44.203,0.371-67.132 c0.071-13.243-10.607-24.039-23.85-24.109l-12.082-0.064c-12.366-0.066-22.445,9.906-22.51,22.272L356.253,269.624z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFB692"
    },
    cx: 384.252,
    cy: 185.29,
    rx: 17.649,
    ry: 8.278
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB692"
    },
    d: "M383.722,117.768h1.012c6.492,0,11.755,8.22,11.755,18.36V186.4h-24.521v-50.271 C371.967,125.989,377.23,117.768,383.722,117.768z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M383.722,117.768h1.012c6.492,0,11.755,7.621,11.755,17.022v34.346 c0,6.771-5.489,12.261-12.261,12.261l0,0c-6.771,0-12.261-5.489-12.261-12.261V134.79 C371.967,125.389,377.23,117.768,383.722,117.768z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252538"
    },
    d: "M371.028,158.854h26.429c6.254,0,11.323-5.069,11.323-11.323v-15.386 c0-13.552-10.986-24.537-24.537-24.537l0,0c-13.551,0-24.537,10.986-24.537,24.537v15.386 C359.705,153.784,364.774,158.854,371.028,158.854z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M359.411,144.914h49.682c2.174,0,3.936-1.762,3.936-3.936l0,0 c0-2.174-1.762-3.936-3.936-3.936h-49.682c-2.174,0-3.936,1.762-3.936,3.936l0,0 C355.475,143.152,357.237,144.914,359.411,144.914z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA635F"
    },
    d: "M409.093,142.887c1.052,0,1.908-0.856,1.908-1.908c0-1.053-0.856-1.909-1.908-1.909h-49.682 c-1.052,0-1.908,0.856-1.908,1.909c0,1.052,0.856,1.908,1.908,1.908H409.093z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB692"
    },
    d: "M384.252,174.687L384.252,174.687c12.133,0,21.969-9.836,21.969-21.969v-20.855 c0-11.632-9.43-21.062-21.062-21.062h-1.814c-11.632,0-21.062,9.43-21.062,21.062v20.855 C362.283,164.851,372.119,174.687,384.252,174.687z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M391.328,137.217h5.049c1.149,0,2.081,0.932,2.081,2.081c0,1.149-0.931,2.081-2.081,2.081 h-5.049c-1.149,0-2.081-0.932-2.081-2.081C389.247,138.149,390.179,137.217,391.328,137.217z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M368.638,137.217h5.049c1.149,0,2.081,0.932,2.081,2.081c0,1.149-0.931,2.081-2.081,2.081 h-5.049c-1.149,0-2.081-0.931-2.081-2.081C366.557,138.149,367.489,137.217,368.638,137.217z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252538"
    },
    d: "M392.248,136.926c1.42,0,2.571,1.151,2.571,2.571c0,1.42-1.151,2.571-2.571,2.571 c-1.42,0-2.571-1.151-2.571-2.571C389.677,138.077,390.828,136.926,392.248,136.926z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252538"
    },
    d: "M372.767,136.926c1.42,0,2.571,1.151,2.571,2.571c0,1.42-1.151,2.571-2.571,2.571 c-1.42,0-2.571-1.151-2.571-2.571C370.196,138.077,371.347,136.926,372.767,136.926z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252538"
    },
    d: "M369.769,132.201l4.457-1.404c0.977-0.308,2.018,0.235,2.326,1.211 c0.308,0.977-0.235,2.018-1.211,2.326l-4.457,1.404c-0.977,0.308-2.018-0.235-2.326-1.212 C368.25,133.549,368.792,132.508,369.769,132.201z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252538"
    },
    d: "M393.388,130.797l4.457,1.404c0.977,0.307,1.519,1.349,1.211,2.326 c-0.308,0.977-1.349,1.519-2.326,1.212l-4.457-1.404c-0.977-0.308-1.519-1.349-1.211-2.326 C391.37,131.031,392.411,130.489,393.388,130.797z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M378.663,163.355c0.199,1.148,2.583,1.695,5.326,1.221c2.743-0.474,4.806-1.789,4.607-2.937 c-0.198-1.148-2.583-1.695-5.326-1.221C380.527,160.892,378.464,162.207,378.663,163.355z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C5C53"
    },
    d: "M388.511,150.491l0.518,0.407c-0.266,0.319-3.876,4.451-11.327,3.828l0.632-0.556 l-0.453-0.515l-1.794,1.578l0.758,0.094c0.852,0.106,1.658,0.154,2.42,0.154c6.783,0,10.007-3.787,10.305-4.157l0.768,0.605 C390.337,151.929,390.546,149.957,388.511,150.491z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252538"
    },
    d: "M374.112,157.708c1.23,0,2.227-0.997,2.227-2.227v0.237c0-2.275,1.851-4.126,4.126-4.126 h6.393c2.276,0,4.126,1.851,4.126,4.126v-0.237c0,1.23,0.997,2.227,2.227,2.227c1.23,0,2.227-0.997,2.227-2.227v0.237 c0-4.731-3.849-8.579-8.58-8.579h-6.393c-4.73,0-8.579,3.849-8.579,8.579v-0.237 C371.885,156.711,372.882,157.708,374.112,157.708z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M382.507,150.177L382.507,150.177c2.021,0,3.659-1.638,3.659-3.659v-5.933 c0-2.021-1.638-3.659-3.659-3.659l0,0c-2.021,0-3.659,1.638-3.659,3.659v5.933 C378.848,148.539,380.487,150.177,382.507,150.177z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F79C97"
    },
    d: "M380.564,148.1L380.564,148.1c0.534,0,0.967-0.433,0.967-0.967v-6.868 c0-0.534-0.433-0.967-0.967-0.967l0,0c-0.534,0-0.967,0.433-0.967,0.967v6.868C379.597,147.667,380.03,148.1,380.564,148.1z "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252538"
    },
    d: "M391.301,122.688l14.607,5.074l0,0c4.108-11.825-2.149-24.741-13.974-28.849l-14.607-5.074 l0,0C373.219,105.665,379.475,118.581,391.301,122.688z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252538"
    },
    d: "M376.859,120.28l10.714,0.802l0,0c0.649-8.674-5.856-16.232-14.531-16.881l-10.715-0.802l0,0 C361.679,112.073,368.184,119.631,376.859,120.28z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464668"
    },
    d: "M367.105,115.913c12.095,3.25,21.504-3.02,21.504-3.02s10.19,4.574,17.588,0.899 c-0.926-3.066-2.493-5.914-4.601-8.342c-4.023,3.402-9.164,5.352-15.429,3.11c0,0-8.771,9.436-23.667-1.474 C363.049,110.503,364.694,113.586,367.105,115.913z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E71C2E"
    },
    d: "M194.039,166.502l70.208-41.873c3.783-2.256,8.655-0.967,10.882,2.879l69.141,119.379 c2.228,3.846,0.967,8.793-2.816,11.049l-70.208,41.873c-3.783,2.256-8.655,0.967-10.882-2.879L191.223,177.55 C188.996,173.704,190.256,168.758,194.039,166.502z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F94E4E"
    },
    points: "309.181,186.302 237.695,257.789 244.251,269.109 315.738,197.623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F94E4E"
    },
    points: "215.505,219.475 231.059,246.33 302.545,174.844 286.991,147.989  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F94E4E"
    },
    points: "317.397,200.487 245.91,271.973 249.047,277.389 320.534,205.903  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1D3244"
    },
    points: "225,148.036 236.743,141.032 313.951,274.339 302.207,281.342  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "249.882,221.103 258.209,216.137 292.902,276.036 284.575,281.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#912C55"
    },
    points: "248.844,149.822 257.172,144.855 322.815,258.196 314.488,263.162  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#912C55"
    },
    points: "225.156,163.539 238.414,186.431 215.9,199.859 202.641,176.967  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB692"
    },
    d: "M326.068,245.541c2.028-7.872-9.764-8.712-9.764-8.712l-6.107-5.557c0,0-4.713,5.654,1.691,9.317 c0,0-7.13,1.78-12.213-0.311c-6.205-2.552-2.984,12.939,2.264,17.282c2.85,2.359,7.205-1.009,11.858-0.478 C320.281,257.823,329.189,254.486,326.068,245.541z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M311.72,249.087l0.143,0.583c0,0-7.418,2.811-13.948,1.63c-0.133-0.338-0.261-0.678-0.38-1.022 C300.109,250.996,304.934,251.571,311.72,249.087z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M312.459,253.469c0,0-6.662,2.606-11.997,2.517c-0.222-0.29-0.437-0.6-0.646-0.923 c2.273,0.084,6.881-0.095,12.505-2.222L312.459,253.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D88D87"
    },
    d: "M311.066,245.039c0,0-7.476,3.097-14.7,0.209c-0.054-0.506-0.083-0.992-0.084-1.45 c2.789,1.212,7.904,2.607,14.662,0.847L311.066,245.039z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB692"
    },
    d: "M335.824,252.307c-10.131,0-16.989-1.17-17.441-1.249l1.722-9.851 c0.164,0.028,16.629,2.803,35.839-0.634c25.102-4.489,42.921-16.978,52.963-37.12l8.949,4.462 c-11.412,22.891-32.321,37.607-60.468,42.558C349.454,251.869,342.025,252.307,335.824,252.307z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB692"
    },
    d: "M335.824,252.307c-10.131,0-16.989-1.17-17.441-1.249l1.722-9.851 c0.164,0.028,16.629,2.803,35.839-0.634c25.102-4.489,42.921-16.978,52.963-37.12l8.949,4.462 c-11.412,22.891-32.321,37.607-60.468,42.558C349.454,251.869,342.025,252.307,335.824,252.307z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464668"
    },
    d: "M401.952,195.647c-1.1,5.291-3.568,14.048-8.915,23.188l17.116,7.432 c0,0,8.616-10.361,10.772-25.902c1.093-7.879-4.704-11.931-10.981-11.582C406.531,188.972,402.648,192.301,401.952,195.647z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9991 -0.043 0.043 0.9991 -5.0046 5.4561)",
    style: {
      fill: "#D7E7FF"
    },
    cx: 124.407,
    cy: 119.135,
    rx: 49.109,
    ry: 49.109
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0535 -0.9986 0.9986 0.0535 13.9754 222.5838)",
    style: {
      fill: "#FFC943"
    },
    cx: 124.407,
    cy: 103.919,
    rx: 54.536,
    ry: 54.536
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD983"
    },
    d: "M71.787,118.196c3.09,11.385,9.84,21.758,19.707,29.207l76.396-76.395 c-4.498-5.95-10.282-11.077-17.244-14.898c-3.865-2.122-7.877-3.711-11.952-4.82L71.787,118.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD983"
    },
    d: "M169.376,73.072l-75.819,75.819c0.991,0.678,2.018,1.318,3.065,1.937l74.704-74.704 C170.712,75.087,170.06,74.071,169.376,73.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD983"
    },
    d: "M173.717,80.643l-72.586,72.586c2.42,1.145,4.885,2.102,7.38,2.865l68.056-68.056 C175.798,85.511,174.845,83.039,173.717,80.643z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9707 -0.2404 0.2404 0.9707 -21.3341 32.9554)",
    style: {
      fill: "#FF833E"
    },
    cx: 124.407,
    cy: 103.919,
    rx: 49.109,
    ry: 49.109
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.4732 -0.881 0.881 0.4732 -26.0098 164.3442)",
    style: {
      fill: "#D7E7FF"
    },
    cx: 124.407,
    cy: 103.919,
    rx: 44.621,
    ry: 44.621
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9996 -0.0276 0.0276 0.9996 -2.8182 3.4699)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 124.407,
    cy: 103.919,
    rx: 38.503,
    ry: 38.503
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M88.393,123.226c0.331,0.587,0.681,1.174,1.041,1.744l3.605-2.274 c-0.323-0.512-0.637-1.038-0.934-1.564L88.393,123.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M125.278,63.149c-0.669-0.028-1.35-0.039-2.023-0.034l0.032,4.263 c0.604-0.005,1.215,0.006,1.815,0.03L125.278,63.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M106.488,71.512l-1.962-3.784c-0.598,0.31-1.197,0.64-1.779,0.98l2.15,3.68 C105.417,72.085,105.952,71.79,106.488,71.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M91.679,85.958c0.281-0.512,0.578-1.023,0.883-1.52l-3.632-2.231 c-0.342,0.556-0.674,1.129-0.988,1.7l-0.029,0.053l3.737,2.051L91.679,85.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M83.044,102.652c-0.006,0.674,0.005,1.357,0.033,2.029l4.259-0.177 c-0.025-0.601-0.035-1.211-0.029-1.814L83.044,102.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M105.4,134.844l-2.218,3.639c0.56,0.341,1.136,0.675,1.711,0.991l0.037,0.021l2.051-3.737 l-0.037-0.021C106.425,135.452,105.906,135.152,105.4,134.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M156.23,123.435l3.629,2.236c0.348-0.565,0.689-1.15,1.012-1.739l0.009-0.016l-3.745-2.035 C156.845,122.408,156.541,122.93,156.23,123.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M160.441,84.651c-0.332-0.589-0.681-1.175-1.039-1.744l-3.608,2.27 c0.321,0.51,0.635,1.037,0.933,1.566L160.441,84.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M123.671,140.43l-0.18,4.258c0.671,0.029,1.352,0.041,2.023,0.036l-0.027-4.262 C124.884,140.467,124.273,140.456,123.671,140.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M165.739,103.203l-4.259,0.171c0.024,0.603,0.033,1.213,0.027,1.813l4.262,0.046 C165.776,104.56,165.766,103.877,165.739,103.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M142.29,136.345l1.958,3.786c0.602-0.311,1.201-0.64,1.78-0.978l-2.146-3.683 C143.364,135.772,142.828,136.067,142.29,136.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M145.669,69.379c-0.574-0.351-1.163-0.692-1.749-1.014l-0.075-0.041l-2.051,3.737l0.075,0.041 c0.529,0.29,1.06,0.598,1.578,0.915L145.669,69.379z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M126.887,99.4c2.453,1.346,3.35,4.426,2.004,6.879c-1.346,2.453-4.426,3.35-6.879,2.004 c-2.453-1.346-3.35-4.426-2.004-6.879C121.355,98.951,124.434,98.053,126.887,99.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M123.64,101.316L123.64,101.316c-0.792-0.012-1.43-0.67-1.418-1.462l0.449-23.646 c0.012-0.792,0.67-1.43,1.462-1.418l0,0c0.792,0.012,1.43,0.67,1.418,1.462l-0.449,23.646 C125.09,100.69,124.432,101.328,123.64,101.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D3244"
    },
    d: "M124.995,103.929L124.995,103.929c-0.411-0.677-0.193-1.568,0.484-1.979l10.266-6.228 c0.677-0.411,1.568-0.193,1.979,0.485l0,0c0.411,0.677,0.193,1.568-0.485,1.978l-10.266,6.228 C126.297,104.825,125.406,104.607,124.995,103.929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7E7FF"
    },
    d: "M125.58,101.782c1.202,0.66,1.642,2.17,0.982,3.372c-0.66,1.202-2.17,1.642-3.372,0.982 c-1.202-0.66-1.642-2.17-0.982-3.372C122.868,101.562,124.377,101.122,125.58,101.782z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingSettlement);
export default __webpack_public_path__ + "static/media/PendingSettlement.da2ef2fe.svg";
export { ForwardRef as ReactComponent };